import gql from 'graphql-tag'

export const GET_SIS_SETTINGS_QUERY = gql`
  query sisSettings {
    siteSettings {
      sisSettings {
        liveRegistration
      }
    }
  }
`

export const GET_PUBLIC_AUTH_SETTINGS_QUERY = gql`
  query publicAuthSettings($environment: String!) {
    publicSettings(environment: $environment) {
      authSettings {
        studentAppAuth0LoginOptions {
          auth0Connection
          label
        }
        enableStudentAppFederatedLogout
        studentAppProvider
        studentAppOidcAuthority
        studentAppOidcClientId
        studentAppOidcAudience
        studentAppOidcDefaultIdpAlias
      }
    }
  }
`

export const APP_SETTINGS_DATA = gql`
  fragment appSettings on SiteSettings {
    academicPlanningSettings {
      advisingUrl
      alwaysShowRequirementCourseAndCreditCounts
      auditRefreshNudgeInterval
      disallowPrimaryPlanRemoval
      disallowSwitchingPlans
      enableAdvisingLink
      enableLockAllPlanItems
      enableMarkAllCommentsAsRead
      courseDisplayFormat
      courseHistoryProgressSummaryOptions
      degreeRequirementsPanelConfiguration
      disableElevio
      disableElevioForStudents
      pastTermYears
      planDisclaimer
      requireTemplatePlanItems
      showExceptionsOnPlanAlerts
      showGradesOnPlanItems
      showWithdrawnStatusOnPlanItems
      hideTermsOffered
      hideRequisitesOnPlanItemDetails
    }
    adminSetting {
      features
    }
    authSettings {
      enableStudentAppFederatedLogout
      studentAppProvider
    }
    cartSettings {
      cartLabel
    }
    homeSettings {
      signoutText
    }
    sectionFieldText {
      credit
      credits
    }
    text {
      advisor
      advisorPlural
      campus
      campusPlural
      course
      coursePlural
      locationPlural
      plannerTitle
      register
      registered
      schedule
      schedulePlural
      term
      termPlural
    }
  }
`

export const GET_APP_SETTINGS_QUERY = gql`
  query appSettings {
    siteSettings {
      ...appSettings
    }
  }
  ${APP_SETTINGS_DATA}
`

export const GET_HOME_SETTINGS_QUERY = gql`
  query homeSettings {
    siteSettings {
      homeSettings {
        signoutText
      }
    }
  }
`

export const HOME_SETTINGS = gql`
  fragment homeSettings on SiteSettings {
    homeSettings {
      signoutText
    }
  }
`

export const NEW_PLAN_SETTINGS = gql`
  fragment newPlanSettings on SiteSettings {
    academicPlanningSettings {
      newPlanTermFilters {
        label
        termType
      }
    }
  }
`

export const GET_NEW_PLAN_SETTINGS_QUERY = gql`
  query newPlanSettings {
    siteSettings {
      ...newPlanSettings
    }
  }
  ${NEW_PLAN_SETTINGS}
`

export const HELP_SETTINGS_DATA = gql`
  fragment helpSettings on SiteSettings {
    academicPlanningSettings {
      planningHelpLinkText
      planningHelpLinkUrl
      planningHelpVideosText
      planningHelpVideosUrl
      studentHelpLinkText
      studentHelpLinkUrl
    }
    helpSettings {
      links {
        description
        key
        title
        url
      }
      videos {
        description
        key
        skillLevel
        subText
        url
      }
    }
    homeSettings {
      customLinkText
      customLinkUrl
      helpText
      helpUrl
    }
  }
`

export const GET_HELP_SETTINGS_QUERY = gql`
  query helpSettings {
    siteSettings {
      ...helpSettings
    }
  }
  ${HELP_SETTINGS_DATA}
`
